var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            {
              ref: "queryFormRef",
              staticClass: "queryFormClass",
              attrs: { model: _vm.queryForm },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("dictionary.dictionaryType") + "：",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: _vm.$t("dictionary.pleaseInput"),
                            },
                            model: {
                              value: _vm.queryForm.params.dictType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "dictType",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryForm.params.dictType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("dictionary.dictionaryName") + "：",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: _vm.$t("dictionary.pleaseInput"),
                            },
                            model: {
                              value: _vm.queryForm.params.dictName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "dictName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryForm.params.dictName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "start" } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.searchTableData },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("dictionary.search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-refresh", size: "mini" },
                        on: { click: _vm.queryFormReset },
                      },
                      [_vm._v(_vm._s(_vm.$t("dictionary.reset")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          plain: "",
                          icon: "el-icon-plus",
                        },
                        on: { click: _vm.addDictType },
                      },
                      [_vm._v(_vm._s(_vm.$t("dictionary.add")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("el-divider"),
        ],
        1
      ),
      _c("el-card", { staticStyle: { "margin-top": "20px" } }, [
        _c(
          "div",
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, height: "500px", border: "" },
                on: { "row-click": _vm.manageData },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "dictType",
                    label: _vm.$t("dictionary.dictionaryType"),
                    "min-width": "180",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "dictName",
                    label: _vm.$t("dictionary.dictionaryName"),
                    "min-width": "120",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    label: _vm.$t("GlobalSetObj.status"),
                    "min-width": "70",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  scope.row.status === 1 ? "success" : "danger",
                                size: "small",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.status === 1
                                      ? _vm.$t("GlobalSetObj.enable")
                                      : _vm.$t("GlobalSetObj.disable")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("dictionary.isSystem"),
                    "min-width": "75",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: scope.row.isSystem ? "success" : "info",
                                size: "small",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.isSystem
                                      ? _vm.$t("dictionary.yes")
                                      : _vm.$t("dictionary.no")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "remark",
                    label: _vm.$t("GlobalSetObj.remark"),
                    "min-width": "140",
                    align: "center",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createUserName",
                    label: _vm.$t("roleManage.creator"),
                    align: "center",
                    "min-width": "90",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: _vm.$t("dictionary.CreationTime"),
                    "min-width": "145",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "updateUserName",
                    label: _vm.$t("roleManage.ModifiedBy"),
                    align: "center",
                    "min-width": "90",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "updateTime",
                    label: _vm.$t("dictionary.ModificationTime"),
                    "min-width": "145",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("dictionary.operation"),
                    align: "center",
                    width: "70",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "operationBtns" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t("dictionary.modify"),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-edit",
                                      size: "small",
                                      disabled: scope.row.isSystem,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.putClick(scope.row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t("dictionary.manageData"),
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-s-operation",
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.manageData(scope.row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("el-pagination", {
              attrs: {
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.queryForm.pageNumber,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.queryForm.pageSize,
                total: _vm.total,
                background: "",
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageNumber", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageNumber", $event)
                },
                "update:pageSize": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageSize", $event)
                },
                "update:page-size": function ($event) {
                  return _vm.$set(_vm.queryForm, "pageSize", $event)
                },
                "size-change": _vm.getTableData,
                "current-change": _vm.getTableData,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.drawerTitle,
            visible: _vm.drawerVisible,
            direction: _vm.direction,
            size: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "drawerContent" },
            [
              _c(
                "el-form",
                {
                  ref: "dictTypeFormRef",
                  attrs: {
                    "label-position": _vm.labelPosition,
                    "label-width": "120px",
                    model: _vm.dictTypeForm,
                    rules: _vm.dictTypeRules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "dictType",
                        label: _vm.$t("dictionary.dictionaryType") + "：",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.isEdit || _vm.isDetail || _vm.isSystemDict,
                          placeholder: _vm.$t("dictionary.dictTypeKeyFormat"),
                        },
                        model: {
                          value: _vm.dictTypeForm.dictType,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictTypeForm, "dictType", $$v)
                          },
                          expression: "dictTypeForm.dictType",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "dictName",
                        label: _vm.$t("dictionary.dictionaryName") + "：",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.isDetail || _vm.isSystemDict,
                          placeholder: _vm.$t("dictionary.pleaseInput"),
                        },
                        model: {
                          value: _vm.dictTypeForm.dictName,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictTypeForm, "dictName", $$v)
                          },
                          expression: "dictTypeForm.dictName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "status",
                        label: _vm.$t("GlobalSetObj.status") + "：",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isDetail || _vm.isSystemDict },
                          model: {
                            value: _vm.dictTypeForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.dictTypeForm, "status", $$v)
                            },
                            expression: "dictTypeForm.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("GlobalSetObj.enable"))),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v(_vm._s(_vm.$t("GlobalSetObj.disable"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.remark") + "：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          disabled: _vm.isDetail || _vm.isSystemDict,
                          placeholder: _vm.$t("dictionary.pleaseInput"),
                        },
                        model: {
                          value: _vm.dictTypeForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictTypeForm, "remark", $$v)
                          },
                          expression: "dictTypeForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.isDetail
                ? _c(
                    "div",
                    { staticClass: "drawerFooter" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.drawerVisible = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.submitDictType },
                        },
                        [_vm._v(_vm._s(_vm.$t("dictionary.submit")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.dataDrawerTitle,
            visible: _vm.dataDrawerVisible,
            direction: _vm.direction,
            size: "85%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dataDrawerVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "drawerContent dataDrawerContent" }, [
            _c(
              "div",
              { staticClass: "dataManageHeader" },
              [
                _c("span", { staticClass: "dictTypeTag" }, [
                  _vm._v(_vm._s(_vm.currentDictType)),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "mini",
                      icon: "el-icon-plus",
                    },
                    on: { click: _vm.addDictData },
                  },
                  [_vm._v(_vm._s(_vm.$t("dictionary.add")))]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "dataTableArea" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.dictDataTable,
                      border: "",
                      height: "100%",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "dictValue",
                        label: _vm.$t("dictionary.dictionaryV"),
                        "min-width": "110",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "dictLabel",
                        label: _vm.$t("dictionary.dictLabel"),
                        "min-width": "110",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("dictionary.multiLangConfig"),
                        "min-width": "160",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "langTags" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: scope.row.dictLabelMap
                                          ? scope.row.dictLabelMap.zh || "-"
                                          : "-",
                                        placement: "top",
                                        disabled: !(
                                          scope.row.dictLabelMap &&
                                          scope.row.dictLabelMap.zh &&
                                          scope.row.dictLabelMap.zh.length > 8
                                        ),
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "langTagText" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dictionary.zhLang")
                                            ) +
                                              ": " +
                                              _vm._s(
                                                scope.row.dictLabelMap
                                                  ? scope.row.dictLabelMap.zh
                                                  : "-"
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: scope.row.dictLabelMap
                                          ? scope.row.dictLabelMap.en || "-"
                                          : "-",
                                        placement: "top",
                                        disabled: !(
                                          scope.row.dictLabelMap &&
                                          scope.row.dictLabelMap.en &&
                                          scope.row.dictLabelMap.en.length > 8
                                        ),
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "langTagText" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dictionary.enLang")
                                            ) +
                                              ": " +
                                              _vm._s(
                                                scope.row.dictLabelMap
                                                  ? scope.row.dictLabelMap.en
                                                  : "-"
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: scope.row.dictLabelMap
                                          ? scope.row.dictLabelMap.pu || "-"
                                          : "-",
                                        placement: "top",
                                        disabled: !(
                                          scope.row.dictLabelMap &&
                                          scope.row.dictLabelMap.pu &&
                                          scope.row.dictLabelMap.pu.length > 8
                                        ),
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "langTagText" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dictionary.puLang")
                                            ) +
                                              ": " +
                                              _vm._s(
                                                scope.row.dictLabelMap
                                                  ? scope.row.dictLabelMap.pu
                                                  : "-"
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "remark",
                        label: _vm.$t("GlobalSetObj.remark"),
                        "min-width": "100",
                        align: "center",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "sortOrder",
                        label: _vm.$t("dictionary.sortOrder"),
                        width: "70",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "status",
                        label: _vm.$t("GlobalSetObj.status"),
                        width: "75",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      scope.row.status === 1
                                        ? "success"
                                        : "danger",
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.status === 1
                                          ? _vm.$t("GlobalSetObj.enable")
                                          : _vm.$t("GlobalSetObj.disable")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("dictionary.isSystem"),
                        width: "85",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: scope.row.isSystem
                                      ? "success"
                                      : "info",
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.isSystem
                                          ? _vm.$t("dictionary.yes")
                                          : _vm.$t("dictionary.no")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createUserName",
                        label: _vm.$t("roleManage.creator"),
                        align: "center",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createTime",
                        label: _vm.$t("dictionary.CreationTime"),
                        "min-width": "150",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "updateUserName",
                        label: _vm.$t("roleManage.ModifiedBy"),
                        align: "center",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "updateTime",
                        label: _vm.$t("dictionary.ModificationTime"),
                        "min-width": "150",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("dictionary.operation"),
                        width: "60",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "operationBtns" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.$t("dictionary.edit"),
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-edit",
                                          size: "small",
                                          disabled: scope.row.isSystem,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.editDictData(scope.row)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    layout: "total, sizes, prev, pager, next",
                    "current-page": _vm.dictDataQuery.pageNumber,
                    "page-sizes": [10, 20, 50],
                    "page-size": _vm.dictDataQuery.pageSize,
                    total: _vm.dictDataTotal,
                    background: "",
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.dictDataQuery, "pageNumber", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.dictDataQuery, "pageNumber", $event)
                    },
                    "update:pageSize": function ($event) {
                      return _vm.$set(_vm.dictDataQuery, "pageSize", $event)
                    },
                    "update:page-size": function ($event) {
                      return _vm.$set(_vm.dictDataQuery, "pageSize", $event)
                    },
                    "size-change": _vm.onDictDataSizeChange,
                    "current-change": _vm.onDictDataPageChange,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.dataFormTitle,
            visible: _vm.dataFormVisible,
            direction: _vm.direction,
            size: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dataFormVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "drawerContent" },
            [
              _c(
                "el-form",
                {
                  ref: "dictDataFormRef",
                  attrs: {
                    "label-position": _vm.labelPosition,
                    "label-width": "120px",
                    model: _vm.dictDataForm,
                    rules: _vm.dictDataRules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "dictValue",
                        label: _vm.$t("dictionary.dictionaryValue") + "：",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.dataEditId !== null,
                          placeholder: _vm.$t("dictionary.pleaseInput"),
                        },
                        model: {
                          value: _vm.dictDataForm.dictValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictDataForm, "dictValue", $$v)
                          },
                          expression: "dictDataForm.dictValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "dictLabel",
                        label: _vm.$t("dictionary.dictLabel") + "：",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("dictionary.pleaseInput"),
                        },
                        model: {
                          value: _vm.dictDataForm.dictLabel,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictDataForm, "dictLabel", $$v)
                          },
                          expression: "dictDataForm.dictLabel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "sortOrder",
                        label: _vm.$t("dictionary.sortOrder") + "：",
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 9999 },
                        model: {
                          value: _vm.dictDataForm.sortOrder,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictDataForm, "sortOrder", $$v)
                          },
                          expression: "dictDataForm.sortOrder",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.status") + "：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.dictDataForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.dictDataForm, "status", $$v)
                            },
                            expression: "dictDataForm.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("GlobalSetObj.enable"))),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v(_vm._s(_vm.$t("GlobalSetObj.disable"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.remark") + "：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: _vm.$t("dictionary.pleaseInput"),
                        },
                        model: {
                          value: _vm.dictDataForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictDataForm, "remark", $$v)
                          },
                          expression: "dictDataForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v(_vm._s(_vm.$t("dictionary.multiLangConfig"))),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("dictionary.zhLang") + "：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("dictionary.pleaseInput"),
                        },
                        model: {
                          value: _vm.dictDataForm.dictLabelMap.zh,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictDataForm.dictLabelMap, "zh", $$v)
                          },
                          expression: "dictDataForm.dictLabelMap.zh",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("dictionary.enLang") + "：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("dictionary.pleaseInput"),
                        },
                        model: {
                          value: _vm.dictDataForm.dictLabelMap.en,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictDataForm.dictLabelMap, "en", $$v)
                          },
                          expression: "dictDataForm.dictLabelMap.en",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("dictionary.puLang") + "：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("dictionary.pleaseInput"),
                        },
                        model: {
                          value: _vm.dictDataForm.dictLabelMap.pu,
                          callback: function ($$v) {
                            _vm.$set(_vm.dictDataForm.dictLabelMap, "pu", $$v)
                          },
                          expression: "dictDataForm.dictLabelMap.pu",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "drawerFooter" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dataFormVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitDictData },
                    },
                    [_vm._v(_vm._s(_vm.$t("dictionary.submit")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }